import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/sections/Header";
import FooterSection from "@/sections/Footer";
import { LandingCurrent } from "@/components/landing/LandingLayouts";

// Re-scrolls to the hash target until async sections above it stop shifting the layout.
const useHashScroll = () => {
  const { hash } = useLocation();
  useEffect(() => {
    const id = decodeURIComponent(hash.slice(1));
    if (!id) return undefined;
    let last = null;
    let stable = 0;
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      const target = document.getElementById(id);
      if (target) {
        const top = Math.round(target.getBoundingClientRect().top + window.scrollY);
        if (top !== last) { target.scrollIntoView({ block: "start" }); last = top; stable = 0; } else stable += 1;
      }
      if (stable >= 4 || tries > 30) clearInterval(timer);
    }, 120);
    const stop = () => clearInterval(timer);
    window.addEventListener("wheel", stop, { once: true, passive: true });
    window.addEventListener("touchstart", stop, { once: true, passive: true });
    return () => { stop(); window.removeEventListener("wheel", stop); window.removeEventListener("touchstart", stop); };
  }, [hash]);
};

export default function Landing() {
  useHashScroll();
  return (
    <main data-testid="landing-page" className="relative">
      <Header />
      <LandingCurrent />
      <FooterSection />
    </main>
  );
}
